import React, { useEffect } from 'react';
import { useAuth } from '../../../services/contexts';
import { backendForFrontend } from '../../../services/utils/axios';
import { OPERATOR_COMMUNICATION_SETTINGS } from '../../../services/utils/units-constants';
import { Spacer, View } from '../../UserDetail/styles';
import {
  Stack,
  Typography,
  Typography as MuiTypography,
  CardContent,
  styled,
  List as MuiList,
  ListItem as MuiListItem,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

const List = styled(MuiList)(() => ({
  paddingLeft: 0,
}));

const ListItem = styled(MuiListItem)(() => ({
  width: '100%',
  display: 'flex',
  paddingLeft: 0,
  alignItems: 'center',
  justifyContent: 'space-between',
}));

function ConfirmOperatorCommunicationSettings({
  payload,
  submit,
  setError,
  setSubmit,
  openFeedback,
}) {
  const { t } = useTranslation();
  const { token } = useAuth();

  useEffect(() => {
    if (submit > 0) updateOperator();
    setSubmit(0);
  }, [submit]);

  const updateOperator = async () => {
    try {
      await backendForFrontend.put(
        '/cpos/update-operator-information',
        {
          cpoId: payload?.cpoId,
          sendEmailToContractUsers: payload?.sendEmailToContractUsers,
          automaticSendBillEmail: payload?.automaticSendBillEmail,
          technicianSendConnectorFaultReport:
            payload?.technicianSendConnectorFaultReport,
          workFlow: 'CommunicationSettings',
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      openFeedback();
    } catch (error) {
      setError(true);
    }
  };

  return (
    <>
      <View>
        <CardContent>
          <Spacer mb={4} />
          <Stack direction="row" sx={{ width: '100%' }}>
            <Box flexGrow={1}>
              <MuiTypography variant="h3" component="h2" gutterBottom>
                {t('LBLCommunicationSettings')}
              </MuiTypography>
              <List>
                {OPERATOR_COMMUNICATION_SETTINGS.map((setting) => (
                  <ListItem key={setting.name}>
                    <Typography>{t(setting.label)}</Typography>
                    <Typography align="right">
                      {(payload?.[setting.name] ?? setting.defaultValue)
                        ? t('yes')
                        : t('no')}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Stack>
        </CardContent>
      </View>
    </>
  );
}
export default ConfirmOperatorCommunicationSettings;
